export const SubscriptionType: any = {
  trial: 'Пробный',
  professional: 'Профессионал',
  team: 'Для команды',
  corp: 'Корпоративный',
};
